export var TaskTemplate;
(function (TaskTemplate) {
    TaskTemplate["CASUAL"] = "casual";
    TaskTemplate["SHARE"] = "share";
    TaskTemplate["INVITE"] = "invite";
    TaskTemplate["LOGIN_TIMES"] = "login_times";
    TaskTemplate["MEMBER_LOGIN_TIMES"] = "member_login_times";
    TaskTemplate["AP_COST"] = "ap_cost";
    TaskTemplate["MEMBER_AP_COST"] = "member_ap_cost";
})(TaskTemplate || (TaskTemplate = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["FAILED"] = -1] = "FAILED";
    TaskStatus[TaskStatus["INITIAL"] = 0] = "INITIAL";
    TaskStatus[TaskStatus["PROCESSING"] = 1] = "PROCESSING";
    TaskStatus[TaskStatus["ACCOMPLISHED"] = 10] = "ACCOMPLISHED";
    TaskStatus[TaskStatus["COMPLETED"] = 20] = "COMPLETED";
})(TaskStatus || (TaskStatus = {}));
// export type TeamData = {
//     activityId: number
//     team: Team
//     // ...
// }
export var CouponStatus;
(function (CouponStatus) {
    CouponStatus[CouponStatus["DEFAULT"] = 0] = "DEFAULT";
    CouponStatus[CouponStatus["DRAWING"] = 1] = "DRAWING";
    CouponStatus[CouponStatus["USED"] = 2] = "USED";
    CouponStatus[CouponStatus["FAILED"] = 3] = "FAILED";
})(CouponStatus || (CouponStatus = {}));
